export default __webpack_public_path__ + "static/224-5757205f911ce1cc9c22ed92c80e06d8.gif";